function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("circle", {
  opacity: 0.1,
  cx: 18,
  cy: 18.5,
  r: 18,
  fill: "#758596"
}), React.createElement("g", {
  clipPath: "url(#clip1)"
}, React.createElement("path", {
  d: "M23 14.3V27.3H13V14.3H23ZM25 12.3H11V27.3C11 28.4 11.9 29.3 13 29.3H23C24.1 29.3 25 28.4 25 27.3V12.3Z",
  fill: "#758596"
}), React.createElement("path", {
  d: "M10 13.3H26",
  stroke: "#758596",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M16 25.2V16.2",
  stroke: "#758596",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M20 25.2V16.2",
  stroke: "#758596",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M20.5 13H15.5V11.3C15.5 10.3 16.3 9.5 17.3 9.5H18.7C19.7 9.5 20.5 10.3 20.5 11.3V13V13Z",
  stroke: "#758596",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 36,
  height: 36,
  fill: "white",
  transform: "translate(0 0.5)"
})), React.createElement("clipPath", {
  id: "clip1"
}, React.createElement("rect", {
  width: 18,
  height: 20.8,
  fill: "white",
  transform: "translate(9 8.5)"
})));

var SvgDeleteIcon = function SvgDeleteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDeleteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete_icon.98a4fa25.svg";
export { ForwardRef as ReactComponent };